import { simpleSet } from '@r/reducers/utils';
import {
  UnitsInputValue
} from '@npmrost/storybook/stories/Vesta/Inputs/UnitsInput';

const setCalculationModeAdminSettingsToeKickHeightLabel = simpleSet as
  redux.reducers.calculationMode.adminSettings.projectSettings.dimensions.toeKickHeight.label;

export const label = setCalculationModeAdminSettingsToeKickHeightLabel(
  'SET_CALCULATION_MODE_ADMIN_SETTINGS_TOE_KICK_HEIGHT_LABEL',
  '' as UnitsInputValue
);
